import axios from 'axios'
export default {
  getListAll(params) {
    return new Promise((resolve, reject) => {
      axios
        .get("leave_day/index/all", {
          params: params
        })
        .then((res) => {
          resolve(res.data.data)
        })
        .catch(() => {
          reject('取得請假錯誤')
        });
    })
  },
}